import { render } from "./SupportRecords.vue?vue&type=template&id=56e829df&scoped=true"
import script from "./SupportRecords.vue?vue&type=script&lang=js"
export * from "./SupportRecords.vue?vue&type=script&lang=js"

import "./SupportRecords.vue?vue&type=style&index=0&id=56e829df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e829df"]])

export default __exports__